import type { BuildingListSections } from "../../../types/buildings-sections/list";

export const buildingList: BuildingListSections = {
  addNewBuilding: "Lisa uus hoone",
  emptyTitle: "Ühtegi hoonet ei leitud",
  emptyDescription: "Loo esimene hoone alustamiseks!",
  errorTitle: "Viga hoonete laadimisel",
  failedToLoad: "Hoonete laadimine ebaõnnestus",
  tryAgain: "Proovi uuesti",
  goHome: "Avalehele",
  archivedTitle: "Arhiveeritud hooned",
  viewActive: "Vaata aktiivseid",
  viewArchived: "Vaata arhiveerituid",
  noBuildingsIntro: "Sul ei ole veel ühtegi hoonet.",
  createNewLink: "Loo uus hoone",
  getStartedSuffix: "et alustada.",
  active: "Aktiivsed",
  archived: "Arhiveeritud",
  searchPlaceholder: "Otsi hooneid ja projekte...",
  searchArchivedPlaceholder: "Otsi arhiveeritud hooneid...",
  noSearchResults: "Ükski hoone ega projekt ei vasta otsingule.",
  noProjectsInBuilding: "Selles hoones pole veel projekte.",
  addProjectLink: "+ Lisa projekt",
  expandProjects: "Näita projekte",
  collapseProjects: "Peida projektid",
  defaultProjectBadge: "Vaikimisi",
  docsLabel: "dokumenti",
  issuesLabel: "avatud ülesannet",
  membersLabel: "liiget",
  projectsCount: "Projektid · {count}",
  projectsLoadFailed: "Projektide laadimine ebaõnnestus.",
  newActivity: "Uued muudatused",
  buildingActions: "Hoone toimingud",
  sortBy: "Sorteeri",
  sortOptions: {
    nameAsc: "Nimi A–Z",
    nameDesc: "Nimi Z–A",
    addressAsc: "Aadress A–Z",
    addressDesc: "Aadress Z–A",
    registryAsc: "Registrikood",
    areaDesc: "Suurim netopind",
    areaAsc: "Väikseim netopind",
  },
};
